// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4deadc6a","455":"1871c64e","977":"1f912864"}[chunkId] + ".chunk.js";
};